import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import Dialog from '../Dialog';
import PreOrderForm from './PreOrderForm';
import OrderForm from './OrderForm';
import OrderPaymentForm from './OrderPaymentForm';
import OrderConfirmation from './OrderConfirmation';
import PreOrderExpired from './PreOrderExpired';
import CouponSnackbar from './CouponSnackbar';
import { getFontFamily } from '../SiteThemeProvider';

function RegisterExtension({
  classes,
  event,
  site,
  section,
  dialogOpen,
  currentStep,
  ticketTypes,
  ticketsCount,
  subtotalValue,
  couponError,
  coupon,
  totalValue,
  openRegisterExtension,
  preOrderChanged,
  nextRegisterExtensionStep,
  createOrder,
  expireRegisterExtension,
  restartRegisterExtension,
  cancelRegisterExtension,
  closeRegisterExtension,
  preOrder,
  preOrderTickets,
  timeOffset,
  setPreOrder,
  installment,
  setInstallments,
  orderError,
  order,
  orderTicketsWithQuantity,
  language,
  animateIn,
  registerFormFields,
}) {
  const { data, styles } = section;
  const stepSection = { styles, data: data.steps[currentStep] || {} };
  let step;

  switch (currentStep) {
    case 0:
      step = (
        <PreOrderForm
          event={event}
          site={site}
          section={stepSection}
          subtotalValue={subtotalValue}
          totalValue={totalValue}
          nextRegisterExtensionStep={nextRegisterExtensionStep}
          setPreOrder={setPreOrder}
          coupon={coupon}
          ticketTypes={ticketTypes}
          ticketsCount={ticketsCount}
          preOrderChanged={preOrderChanged}
        />
      );
      break;
    case 1:
      step = (
        <OrderForm
          event={event}
          site={site}
          section={stepSection}
          preOrder={preOrder}
          preOrderTickets={preOrderTickets}
          timeOffset={timeOffset}
          ticketsCount={ticketsCount}
          onPreOrderExpired={expireRegisterExtension}
          nextRegisterExtensionStep={nextRegisterExtensionStep}
          language={language}
          onSubmit={createOrder}
          registerFormFields={registerFormFields}
        />
      );
      break;
    case 2:
      step = (
        <OrderPaymentForm
          event={event}
          site={site}
          section={stepSection}
          preOrder={preOrder}
          timeOffset={timeOffset}
          ticketsCount={ticketsCount}
          installment={installment}
          setInstallments={setInstallments}
          onPreOrderExpired={expireRegisterExtension}
          onSubmit={createOrder}
          orderError={orderError}
        />
      );
      break;
    case 3:
      step = (
        <OrderConfirmation
          event={event}
          site={site}
          section={stepSection}
          order={order}
          orderTicketsWithQuantity={orderTicketsWithQuantity}
          onConfirm={closeRegisterExtension}
        />
      );
      break;
    case 4:
      step = (
        <PreOrderExpired
          event={event}
          site={site}
          section={stepSection}
          onRestart={restartRegisterExtension}
        />
      );
      break;
    default:
      step = null;
  }

  return (
    <span className={classes.root}>
      <Dialog
        key="dialog"
        open={dialogOpen}
        className={classes.dialog}
        onRequestClose={cancelRegisterExtension}
        escToClose={false}
        closeInOverlay={false}
        animateIn={animateIn}
      >
        {step}
      </Dialog>
      <CouponSnackbar
        key="snackbar"
        error={couponError}
        coupon={coupon}
        onClick={openRegisterExtension}
      />
    </span>
  );
}

RegisterExtension.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  dialogOpen: PropTypes.bool.isRequired,
  currentStep: PropTypes.number.isRequired,
  ticketsCount: PropTypes.number.isRequired,
  subtotalValue: PropTypes.number.isRequired,
  totalValue: PropTypes.number.isRequired,
  openRegisterExtension: PropTypes.func.isRequired,
  expireRegisterExtension: PropTypes.func.isRequired,
  restartRegisterExtension: PropTypes.func.isRequired,
  cancelRegisterExtension: PropTypes.func.isRequired,
  closeRegisterExtension: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  ticketTypes: PropTypes.array,
  preOrder: PropTypes.object,
  preOrderTickets: PropTypes.array,
  timeOffset: PropTypes.number,
  order: PropTypes.object,
  orderTicketsWithQuantity: PropTypes.array,
  coupon: PropTypes.object,
  couponError: PropTypes.object,
  createOrder: PropTypes.func.isRequired,
  preOrderChanged: PropTypes.func.isRequired,
  installment: PropTypes.object,
  orderError: PropTypes.object,
  animateIn: PropTypes.bool,
  setInstallments: PropTypes.func.isRequired,
  nextRegisterExtensionStep: PropTypes.func.isRequired,
  setPreOrder: PropTypes.func.isRequired,
  registerFormFields: PropTypes.array.isRequired,
};

RegisterExtension.defaultProps = {
  ticketTypes: null,
  totalValue: null,
  preOrder: null,
  preOrderTickets: null,
  timeOffset: null,
  orderError: null,
  order: null,
  orderTicketsWithQuantity: null,
  couponError: null,
  coupon: null,
  installment: null,
  animateIn: undefined,
};

const styles = {
  root: {
    fontFamily: props => getFontFamily(props.site),
  },
  dialog: {
    padding: 0,
  },
};

export default injectSheet(styles)(RegisterExtension);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/RegisterExtension.js